import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getBulkAccountsStatusesProgress,
    stopAccountStatusBulkUpdate,
    updateAccountStatus,
} from 'src/openapi/admin/apis/AccountStatusBulkUpdateApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UpdateAccountStatusModal} from './update-account-status.modal';
import {
    selectUpdateAccountStatusBulkUuid,
    selectUpdateAccountStatusTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './update-account-status.slice';

import type {UpdateAccountStatusRequest} from 'src/openapi/admin/models/UpdateAccountStatusRequest';

type Props = {
    shown: boolean,
    accountIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UpdateAccountStatusTool = ({shown, onClose, accountIds, onDone}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateAccountStatusRequest>
            shown={shown}
            onClose={onClose}
            width={400}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateAccountStatusTask}
            uuidSelector={selectUpdateAccountStatusBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateAccountStatusRequest, options) => (
                apiDispatch(updateAccountStatus({...options, updateAccountStatusRequest}))
            )}
            getProgress={id => apiDispatch(getBulkAccountsStatusesProgress({id}))}
            stopAction={id => apiDispatch(stopAccountStatusBulkUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateAccountStatusModal {...{accountIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
